const cart = {
  en: {
    translation: {
      title: "My Cart",
      subtotal: "Subtotal",
      delivery_costs: "Delivery fee",
      service_fees: "Service fee",
      discount: "Discount",
      total: "Total",
      promotional_code: "Promotional Code",
      checkout: "Checkout",
      add_to_cart: "Add to cart",
      add: "Add",
      go_to_cart: "Go to cart",
      add_tickets: "Add tickets",
      empty_cart: "Your shopping cart is empty",
      apply: "Apply code",
      remove: "Remove code",
      min_cost: "Min expense",
      cover_price: "Cover price",
      // menu
      menu: "Menu",
      // INFO ALERT
      info_title: "Please note: delivery info",
      info_description: "Delivery is available for the following cities:",
      info_title_both: "This business has both delivery and take-away",
      info_description_both: "",
      service_available: "The service is available on: ",
      // MIN TOTAL
      min_total_title: "MINIMUM SPEND",
      min_total_description:
        " For this business, there is a minimum order value of",
      // PRICE PER HG
      gMin: "The minimum value is",
      gMax: "The maximum value is",
      gLevel: "The add value is",
      gPrice: "The price is",
      // PROMOTIONAL CODE ALERT
      promotional_title_success: "Good job",
      promotional_description_success:
        "The code is valid and has been applied correctly",
      promotional_error_title: "Caution!",
      promotional_NO_VALID: "The code is invalid",
      promotional_NO_TIME_VALID: "The code expired or is not actived yet",
      promotional_GENERAL_ERROR:
        "The code does not exist or is not yet activate",
      orderSummary: "Order summary",
      ticketNumber: "N. Tickets",
      showDetails: "Show details",
      hideDetails: "Hide details",
      tooManyTicketsForTheSlot:
        "You cannot add any more ticket for the time slot ",
    },
  },
  it: {
    translation: {
      title: "Il mio carrello",
      subtotal: "Subtotale",
      delivery_costs: "Spese di consegna",
      service_fees: "Spese di servizio",
      discount: "Sconto",
      total: "Totale",
      promotional_code: "Codice Promozionale",
      checkout: "Vai alla cassa",
      add_to_cart: "Aggiungi al carrello",
      add: "Aggiungi",
      go_to_cart: "Vai al carrello",
      add_tickets: "Aggiungi biglietto",
      empty_cart: "Il tuo carrello è vuoto",
      apply: "Applica codice",
      remove: "Rimuovi codice",
      min_cost: "Min spesa",
      cover_price: "Spesa coperti",
      // menu
      menu: "Menu",
      // INFO ALERT
      info_title: "Attenzione! Informazioni sulla consegna",
      info_description: "La consegna è prevista per le seguenti città:",
      info_title_both:
        "Questa attività ha sia l'asporto sia la consegna a domicilio",
      info_description_both: "",
      service_available: "Il servizio viene effettuato nei seguenti giorni: ",
      // MIN TOTAL
      min_total_title: "ORDINE MINIMO",
      min_total_description:
        "Per questa struttura è previsto un ordine minimo di",
      // PRICE PER HG
      gMin: "Il valore minimo è",
      gMax: "Il valore massimo è",
      gLevel: "Il valore di aggiunta è",
      gPrice: "Il prezzo è",
      // PROMOTIONAL CODE ALERT
      promotional_title_success: "Buon lavoro",
      promotional_description_success:
        "Il codice è valido ed è stato applicato corretamente",
      promotional_error_title: "Attenzione!",
      promotional_NO_VALID: "Il codice non è valido",
      promotional_NO_TIME_VALID:
        "Il codice è scaduto o non è ancora stato attivato",
      promotional_NO_MIN_COST:
        "Il codice è valido ma non hai ancora raggiunto la minima spesa",
      promotional_GENERAL_ERROR:
        "Il codice non esiste o non è ancora stato attivato",
      orderSummary: "Riepilogo ordine",
      ticketNumber: "N. Biglietti",
      showDetails: "Mostra dettagli",
      hideDetails: "Nascondi dettagli",
      tooManyTicketsForTheSlot:
        "Non puoi aggiungere altri biglietti per lo slot ",
    },
  },
};

export default cart;
